module.exports = __webpack_public_path__ + "img/chart.15fe45db.svg";